import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { OrderDTO } from '../../../../../shared/order-dto';

@Component({
  selector: 'pv-email-auth',
  templateUrl: './email-auth.component.html',
  styleUrls: ['./email-auth.component.scss']
})
export class EmailAuthComponent implements OnInit {
  @Input() order: OrderDTO;
  @Output() success: EventEmitter<void> = new EventEmitter<void>();
  email: string = '';
  message: string = '';

  constructor() { }

  ngOnInit() {
  }

  authorizeEmail() {
    console.log('going')
    if (this.email.toLowerCase() == this.order.shippingAddress.email.toLowerCase()) {
      this.success.emit();
    } else {
      console.log('new message')
      this.message = 'Incorrect Email Address, Please Try Again'
    }
  }

}
